<template>
  <section class="subject">
    <section class="subject-container-left subject-wrap">
      <!-- <div class="searchBox">
        <input type="text" v-model="content" class="searchInput" placeholder="搜索" @keyup.enter="jumpSearch()">
        <span class="searchBtn iconfont" @click="jumpSearch()">&#xe633;</span>
      </div>-->
      <section class="subject-body">
        <h3>
          <p
            @click="changeTag('allTopics')"
            :class="[{'foucus':focus === 'allTopics'}]"
          >
            {{ $t('subject.all-subject') }}
          </p>
          <p
            @click="changeTags('myAttention')"
            :class="[{'foucus':focus === 'myAttention'}]"
          >
            {{ $t('subject.my-focus') }}
          </p>
        </h3>
        <section class="themeList">
          <allTopics
            v-if="focus === 'allTopics'"
            :allThemeData="allThemeData"
            @moreAllTheme="refresh"
          ></allTopics>
          <myAttention
            v-else-if="focus === 'myAttention'"
            :myThemeData="myThemeData"
            @moreMyTheme="refresh"
          ></myAttention>
          <div
            v-if="isShow && focus === 'myAttention'"
            class="pagination"
          >
            <pagination
              v-if="mypaginationShow"
              :currentPage="mycurrentPage"
              :total="mytotal"
              limit="15"
              layout="jumper"
              :goTop="mygoTop"
              @current-change="mypageChange"
            ></pagination>
            <div
              class="default"
              v-if="!mypaginationShow"
            >
              <img
                src="https://cdn.gelonghui.com/static/web/nothing.png"
                alt
              >
              <p class="defaultText">暂时木有关注主题~</p>
            </div>
          </div>
          <div
            v-if="isShow  && focus === 'allTopics'"
            class="pagination"
          >
            <pagination
              v-if="paginationShow"
              :currentPage="currentPage"
              :total="total"
              limit="15"
              layout="jumper"
              :goTop="goTop"
              @current-change="pageChange"
            ></pagination>
            <div
              class="default"
              v-if="!paginationShow"
            >
              <img
                src="https://cdn.gelonghui.com/static/web/nothing.png"
                alt
              >
              <p class="defaultText">暂时木有主题~</p>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="subject-container-right">
      <hotTheme
        class="hotTheme"
        ref="hotTheme"
        @refresh="refresh"
        :hotThemeData="hotThemeData"
        @hotSubject="getHotSubject"
      ></hotTheme>
    </section>
  </section>
</template>
<script>
import {
  mapMutations,
  mapGetters,
  mapState,
  mapActions
} from "vuex";
import * as types from "~/types";
import allTopics from "~/components/subject/alltopics";
import myAttention from "~/components/subject/my-attention";
import hotTheme from "~/components/subject/hot-subject";
import pagination from "~/components/public/component-pagination";
import * as api from "~/api/index";
export default {
  layout: "subject",
  async asyncData({
    params,
    query,
    route,
    error,
    app,
    req,
    store,
    $axios
  }) {
    try {

      const headers = req && req.headers;
      //获取热门主题, 这个时候不用传headers进去,默认是未登陆状态,,,当热门主题小于五条时,需要获取我关注的热门主题,获取不到userID,,登陆成功,客户端会监听登陆状态
      let [allThemeData, hotThemeData, fillData] = await Promise.all([
        $axios(
          api.allTheme({
            page: 1,
            limit: 15,
            headers: headers
          })
        ),
        $axios(
          api.hotTheme({
            page: 1,
            headers: headers
          })
        ),
        $axios(
          api.getMyFocus({
            id: -1,
            page: 1,
            isHot: true,
            limit: 15,
            headers: headers
          })
        )
      ])
      let total = allThemeData.totalCount;

      if (hotThemeData && hotThemeData.result && hotThemeData.result.length > 0) {
        if (hotThemeData.result && hotThemeData.result.length < 5) {
          let length = 5 - hotThemeData.result.length;
          let focusItem = fillData && fillData.result ? fillData.result.slice(0, length) : [];
          hotThemeData = [...hotThemeData.result, ...focusItem];
        } else if (hotThemeData.result && hotThemeData.result.length >= 5) {
          hotThemeData = hotThemeData.result.slice(0, 5);
        } else {
          hotThemeData = fillData && fillData.result ? fillData.result.slice(0, 5) : [];
        }
      } else {
        hotThemeData = []
      }


      return {
        allThemeData: allThemeData.result ? allThemeData.result : [],
        total: total,
        hotThemeData: hotThemeData,

      };
    } catch (err) {
      console.log(err);
      error({
        statusCode: 404,
        message: "文章不存在"
      });
    }
  },
  data() {
    return {
      focus: "allTopics",
      content: "",
      goTop: true,
      paginationShow: true,
      total: 0,
      isShow: true,
      currentPage: 1,
      myThemeData: [],
      mygoTop: true,
      mypaginationShow: false,
      mytotal: 0,
      mycurrentPage: 1
    };
  },
  components: {
    allTopics,
    myAttention,
    hotTheme,
    pagination
  },
  computed: {
    ...mapGetters("user", ["isLogin", "userId"])
  },
  methods: {
    async changeTag(way) {
      this.focus = way;
      this.currentPage = 1;
      let firstThemeData = await this.$axios(
        api.allTheme({
          page: this.currentPage,
          limit: 15 // 后端默认15条
        })
      );
      this.total = firstThemeData.totalCount;
      this.allThemeData = firstThemeData.result;
      this.isShow = true;
      if (this.total > 0) {
        this.paginationShow = true;
      } else {
        this.paginationShow = false;
      }
    },
    async changeTags(way) {
      // this.isShow = false;
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.focus = way;
      this.mypaginationShow = false;
      this.currentPage = 1;
      let myThemeData = await this.$axios(
        api.getMyFocus({
          id: this.userId,
          page: this.currentPage,
          isHot: false,
          limit: 15
        })
      );
      if (myThemeData && myThemeData.result) {
        this.isShow = true;
        this.mytotal = myThemeData.totalCount;
        this.myThemeData = myThemeData.result;
        this.mypaginationShow = true;
      } else {
        this.isShow = true;
        this.mypaginationShow = false;
      }
    },
    async moreAllTheme() {
      // this.isShow = false;
      let allThemeData = await this.$axios(
        api.allTheme({
          page: this.currentPage,
          limit: 15 // 后端默认15条
        })
      );

      this.total = allThemeData.totalCount;
      if (this.total > 0) {
        this.paginationShow = true;
      } else {
        this.paginationShow = false;
      }
      this.allThemeData =
        allThemeData && allThemeData.result ? allThemeData.result : [];
      this.isShow = true;
    },
    async moreMyTheme() {
      // this.isShow = false;
      let myThemeData = await this.$axios(
        api.getMyFocus({
          id: this.userId,
          page: this.mycurrentPage,
          isHot: false,
          limit: 15 // 后端默认15条
        })
      );

      this.mytotal = myThemeData.totalCount;
      if (this.mytotal > 0) {
        this.mypaginationShow = true;
      } else {
        this.mypaginationShow = false;
      }
      this.myThemeData =
        myThemeData && myThemeData.result ? myThemeData.result : [];
      this.isShow = true;
    },
    pageChange(internalCurrentPage) {
      this.currentPage = internalCurrentPage;
      this.moreAllTheme();
    },
    mypageChange(internalCurrentPage) {
      this.mycurrentPage = internalCurrentPage;
      if (!this.isLogin) {
        return;
      }
      this.moreMyTheme();
    },
    async getHotSubject() {
      let hotThemeData = await this.$axios(
        api.hotTheme({
          page: 1
        })
      );
      let fillData = null
      if (this.userId) {
        fillData = await this.$axios(
          api.getMyFocus({
            id: this.userId,
            page: 1,
            limit: 15,
            isHot: true
          })
        );
      }

      if (hotThemeData && hotThemeData.result && hotThemeData.result.length > 0) {
        if (hotThemeData.result && hotThemeData.result.length < 5) {
          let length = 5 - hotThemeData.result.length;
          let focusItem = fillData.result.slice(0, length);
          this.hotThemeData = [...hotThemeData.result, ...focusItem];
        } else if (hotThemeData.result && hotThemeData.result.length >= 5) {
          this.hotThemeData = hotThemeData.result.slice(0, 5);
        } else {
          this.hotThemeData = fillData && fillData.result ? fillData.result.slice(0, 5) : []
        }
      } else {
        this.hotThemeData = []
      }
    },
    refresh() {
      if (this.mycurrentPage !== 1 && this.mytotal === 15 * (this.mycurrentPage - 1) + 1) {
        this.mycurrentPage--
      }
      this.moreAllTheme();
      this.moreMyTheme();
      this.getHotSubject();

    },
    ...mapMutations("user", [types.SHOW_LOGIN_FORM])
  },
  mounted() {
    // if (this.focus === "allTopics") {
    //   this.moreAllTheme();
    // } else if (this.focus === "myAttention") {
    //   this.moreMyTheme();
    // }
  },
  head() {
    return {
      title: '货币交易走势_创业板公司涨跌-格隆汇',
      meta: [
        {
          hid: "description",
          name: "description",
          content: '格隆汇主题栏目对社会各个行业及热点话题进行了专业角度的分析,以便大家对这些信息有更好的了解和认知,欢迎大家访问格隆汇官网.'
        },
        {
          hid: "keywords",
          name: "keywords",
          content: '货币交易走势,创业板公司涨跌'
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.gelonghui.com/subject"
        },
        {
          rel: "alternate",
          media: "only screen and (max-width:640px)",
          href: `https://m.gelonghui.com/subject/`
        }
      ]
    };
  }
};

</script>
<style lang="less" scoped>
.subject {
  width: 1200px;
  min-height: 500px;
  margin: auto;
  padding-bottom: 100px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  _zoom: 1;

  .subject-wrap {
    width: 852px;
    background-color: #ffffff;
    position: relative;
    margin-top: 20px;
    padding: 0 22px 50px;
    clear: both;

    .searchBox {
      position: relative;
      margin-top: 15px;
      display: inline-block;
      width: 808px;
      height: 48px;
      border-radius: 20px;
      background-color: rgba(131, 141, 151, 0.1);
      border-radius: 24px;

      .searchBtn {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 15px;
        font-size: 18px;
        margin: auto;
        cursor: pointer;
        color: #838d97;
      }

      .searchInput {
        box-sizing: border-box;
        display: inline-block;
        font-size: 16px;
        border: none;
        width: 100%;
        height: 100%;
        padding: 12px 0 13px 20px;
        border-radius: 24px;
        background-color: transparent;
        outline: none;

        &:focus {
          border: 1px solid #1677d9;
          background: #fff;
          outline: 2px;
        }
      }
    }

    .subject-body {
      width: 100%;
      display: flex;
      // flex-direction: column;

      h3 {
        position: relative;
        margin-top: 20px;
        width: 148px;
        padding-left: 12px;
        font-size: 16px;
        line-height: 56px;
        color: rgba(102, 102, 102, 1);

        p {
          margin-right: 10px;
          cursor: pointer;
          position: relative;
        }

        p.foucus {
          font-weight: 600;
          color: rgba(34, 34, 34, 1);

          &::after {
            content: "";
            position: absolute;
            bottom: 20px;
            left: -12px;
            width: 3px;
            height: 16px;
            background: rgba(50, 120, 210, 1);
          }
        }

        &::after {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 1px;
          height: 96%;
          border-left: 1px dotted rgba(232, 232, 232, 1);
        }
      }

      .default {
        width: 100%;
        margin: 80px auto;
        text-align: center;

        img {
          width: 294px;
        }

        p {
          text-align: center;
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
        }
      }

      .themeList {
        min-width: 550px;

        .pagination {
          position: absolute;
          left: 33%;
          bottom: 10px;
        }
      }
    }
  }

  .subject-container-right {
    width: 328px;
    position: relative;

    .hotTheme {
      margin-top: 20px;
      position: sticky;
      top: 120px;
    }
  }
}
</style>
